import React from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { formDataPush } from "../client_onboard/ResellerDetails";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";
import { SS_AUTH_TOKEN } from "../../../../../utility/constants/secureStorageManager";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { useEffect } from "react";
import { removeServiceData } from "../../../../../data/redux/slice/addService";
import { fullScreenLoadingSlice } from "../../../../../data/redux/slice/loaderSlice";
import secureStorage from "../../../../../services/secureStorage";

const TranscationLimits = ({
  onClickNext,
  onClickPrevious,
  onClickCancel,
  goToPage,
  clientDetails,
  onSuccess,
}) => {
  const reduxData = useSelector((state) => state.addService);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const updateAddservice = () => {
    dispatch(fullScreenLoadingSlice(true));

    let service = [];

    service.push(reduxData?.service);

    const formdata = formDataPush({
      ...reduxData,
      service: JSON.stringify(service),
      clientId: clientDetails?.userId,
    });
     const token = secureStorage.getItem(SS_AUTH_TOKEN);

    fetch(API_ENDPOINT.core_url + "client/update/addservice", {
      body: formdata,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        dispatch(fullScreenLoadingSlice(false));
      });
  };

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
      }}
    >
      <p style={styles.title}>Transaction Limits</p>
      <p style={styles.p1}>
        Please provide the bank details as mentioned below
      </p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C",
        }}
      ></div>

      <div
        style={{
          color: "#6C6B6B",
          margin: "3% 0% 1% 0%",
        }}
      >
        Set Transaction Volume Limit
      </div>

      <div
        style={{
          marginLeft: "2% 0%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px",
        }}
      >
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Min Transaction Volume /per day</label>
          <CustomInput
            disabled={"disabled"}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 01 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Max Transaction Volume /per day</label>
          <CustomInput
            disabled={"disabled"}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 8,00,000 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      </div>

      <div
        style={{
          color: "#6C6B6B",
          margin: "3% 0% 1% 0%",
        }}
      >
        Set Transaction Value Limit
      </div>

      <div
        style={{
          marginLeft: "2% 0%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px",
        }}
      >
        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Min Transaction Value /per day</label>
          <CustomInput
            disabled={"disabled"}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 01 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>

        <div style={{ minWidth: "343px" }}>
          <label style={styles.label}>Max Transaction Value /per day</label>
          <CustomInput
            disabled={"disabled"}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="eg : 8,00,000 /per day"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
        }}
      >
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              let service_providerName =
                reduxData?.service?.serviceProviderName?.toLowerCase();
              clientDetails?.service?.map((e) => {
                if (
                  e.serviceType.toLowerCase() === "payin" ||
                  e.serviceType.toLowerCase() === "voucher"
                ) {
                  if (
                    reduxData?.service?.serviceType?.toLowerCase() === "van" ||
                    reduxData?.service?.serviceType?.toLowerCase() ===
                      "van-upi" ||
                    reduxData?.service?.serviceType?.toLowerCase() === "voucher"
                  ) {
                    goToPage(3);
                  } else {
                    goToPage(4);
                  }
                } else if (e.serviceType.toLowerCase() === "payout") {
                  if (
                    reduxData?.service?.serviceType?.toLowerCase() === "van" ||
                    reduxData?.service?.serviceType?.toLowerCase() === "voucher"
                  ) {
                    goToPage(4);
                  } else if (
                    service_providerName === "1pay" ||
                    service_providerName === "fino"
                  ) {
                    goToPage(4);
                  } else {
                    goToPage(5);
                  }
                }
                if (e.serviceType.toLowerCase() === "van") {
                  if (
                    reduxData?.service?.serviceType?.toLowerCase() === "payin"
                  ) {
                    if (service_providerName === "kopay") {
                      goToPage(5);
                    }
                    if (
                      service_providerName === "1pay" ||
                      service_providerName === "fino"
                    ) {
                      goToPage(3);
                    }
                  } else if (
                    reduxData?.service?.serviceType?.toLowerCase() ===
                      "voucher" ||
                    reduxData?.service?.serviceType?.toLowerCase() === "van-upi"
                  ) {
                    goToPage(3);
                  } else {
                    goToPage(4);
                  }
                }
                if (e.serviceType.toLowerCase() === "voucher") {
                  if (
                    reduxData?.service?.serviceType?.toLowerCase() === "payin"
                  ) {
                    if (service_providerName === "kopay") {
                      goToPage(5);
                    }
                    if (
                      service_providerName === "1pay" ||
                      service_providerName === "fino"
                    ) {
                      goToPage(3);
                    }
                  } else if (
                    reduxData?.service?.serviceType?.toLowerCase() === "van"
                  ) {
                    goToPage(3);
                  } else {
                    goToPage(4);
                  }
                }
              });
            }}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              updateAddservice();
            }}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  title: {
    fontSize: "24px",

    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "300px",
  },
  p1: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px",
    margin: "10px 0 10px 0",
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
  select: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#001053",
  },
  add: {
    width: "250px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "6px",
    margin: "10px 0",
  },
  addUrl: {
    width: "160px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "6px",
    margin: "10px 0",
    cursor: "Pointer",
  },
};

export default TranscationLimits;
